export default __webpack_public_path__ + "static/univers-black-bc4b0b95cef83656a07f199d73fe77be.woff";